import { Component, Event, EventEmitter, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

import { Store } from '../../../utils/Stores/store';

@Component({
  tag: 'tickets-module-component',
  styleUrl: 'tickets-module.scss',
  shadow: true,
})
export class ModuleTickets {
  @Event() sectionChangeEvent: EventEmitter<IWCContextClose[]>;
  @Event() closeEvent: EventEmitter;
  @Prop() readonly tickets: SupportTicket[] = [];

  private handleTicketClick(id: number) {
    Store?.set('currentTicketId', id);
    this.sectionChangeEvent.emit(['ticket_details']);
  }

  private renderActionButton(id: number) {
    return (
      <div class="ticket-summary-action">
        <button onClick={() => this.handleTicketClick(id)}>
          {wcShared.translate('Voir le ticket')}
        </button>
      </div>
    );
  }

  private renderTicketSummary(ticket: SupportTicket) {
    return (
      <button
        class="ticket-summary-container"
        onClick={() => this.handleTicketClick(ticket.id)}
      >
        <ticket-summary-component ticket={ticket}></ticket-summary-component>
        {this.renderActionButton(ticket.id)}
      </button>
    );
  }

  render() {
    return (
      <Host>
        <div class={{ tickets: true, full: Store?.get('is_full') }}>
          <div class="tickets__subtitle">
            {wcShared.translate('Voici les derniers tickets de support que vous avez ouverts.')}
          </div>
          <div class="ticket-list">
            {this.tickets.map((ticket) => {
              return this.renderTicketSummary(ticket);
            })}
          </div>
        </div>
      </Host>
    );
  }
}
